import { combineReducers, bindActionCreators } from 'redux'

import Auth from './Auth'

const actionList = {
  ...Auth.actions,
}

const reducerList = {
  auth: Auth.reducer,
}

export const reducers = combineReducers(reducerList)

export const actions = (dispatch) => ({
  actions: bindActionCreators(actionList, dispatch),
})
